import React from "react";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Box, Typography, Link, Container } from "@mui/material";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "grey.100",
      }}
    >
      <Container maxWidth="sm">
        <Box sx={{ textAlign: "center" }}>
          <Typography variant="h1" sx={{ mb: 2, fontWeight: "bold", fontSize: "4rem" }}>
            404
          </Typography>
          <Typography variant="h5" sx={{ mb: 3, color: "text.secondary" }}>
            Oops! Page not found
          </Typography>
          <Link
            href="/"
            sx={{
              color: "primary.main",
              textDecoration: "underline",
              "&:hover": {
                color: "primary.dark",
                textDecoration: "underline",
              },
            }}
          >
            Return to Home
          </Link>
        </Box>
      </Container>
    </Box>
  );
};

export default NotFound;
